export const XS = 480;
export const SM = 600;
export const LT = 768;
export const HEADER = 942;
export const LPX = 992;
export const DP = 1170;